import ProviderSectionContainer, {
  PROVIDER_SECTION_IDS,
} from 'app/ProviderDetails/ProviderSectionContainer'
import styles from './index.module.scss'
import { Card } from '@/base_components/ui/card'
import Icon from 'common/Icon'
import { SPUN_PEARL } from 'constants/colors'
import ScrollHorizontally from 'common/ScrollHorizontally'

type BlogsProps = {
  blogs: BlogMeta[]
}

const Blogs: React.FC<BlogsProps> = ({ blogs = [] }) => {
  if (!blogs?.length) {
    return null
  }

  return (
    <ProviderSectionContainer
      heading="Media and Blogs"
      id={PROVIDER_SECTION_IDS.BLOGS}
    >
      <ScrollHorizontally containerClass="~w-full" redesignScroll={true}>
        <div className={`${styles.container} ~pl-0 ~pb-6 ~flex ~mb-6`}>
          {blogs.map((blog, index) => (
            <div className="~mr-4" key={`${index}-${blog.url}`}>
              <a href={blog.url} target="_blank" rel="noreferrer">
                <Card className={`${styles.blog_card} ~relative`}>
                  {!!blog.image && (
                    <img
                      src={blog.image.url}
                      alt={blog.title}
                      className="~w-full ~h-full ~object-cover app-border-radius"
                    />
                  )}
                  <div
                    className={`${styles.blog_img_overlay} ~p-0 ~pl-4 ~pr-6 ~flex ~flex-col ~justify-end app-border-radius ~absolute ~inset-0`}
                  >
                    <div className="~text-white ~text-sm ~font-bold ~mb-2">
                      {blog.title}
                    </div>
                    <div className="~flex ~items-center ~mb-4">
                      <div className="~text-white ~font-medium ~mr-2 opacity-6">
                        Read
                      </div>
                      <Icon
                        icon="readMoreForward"
                        fill={SPUN_PEARL}
                        className="fa-lg"
                      />
                    </div>
                  </div>
                </Card>
              </a>
            </div>
          ))}
        </div>
      </ScrollHorizontally>
    </ProviderSectionContainer>
  )
}

export default Blogs
